module.exports = __webpack_public_path__ + "static/media/map3.908898de.PNG";